/* Nude Glow — interacciones (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ng-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ng-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ng-visible');
        if (entry.target.hasAttribute('data-ng-count')) countUp(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var num = el.querySelector('[data-ng-num]');
    if (!num || reduceMotion) return;
    var raw = num.getAttribute('data-ng-num');
    var match = raw.match(/^(\D*)([\d.,]+)(.*)$/);
    if (!match) return;
    var prefix = match[1], suffix = match[3];
    var target = parseFloat(match[2].replace(',', '.'));
    if (isNaN(target)) return;
    var decimals = (match[2].split(/[.,]/)[1] || '').length;
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      num.textContent = prefix + (target * eased).toFixed(decimals).replace('.', ',') + suffix;
      if (p < 1) requestAnimationFrame(step); else num.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  function initGaleria() {
    document.querySelectorAll('[data-ng-galeria]').forEach(function (gal) {
      var main = gal.querySelector('[data-ng-main]');
      if (!main) return;
      gal.querySelectorAll('[data-ng-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-ng-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = btn.getAttribute('data-src');
            main.srcset = btn.getAttribute('data-srcset') || '';
            main.alt = btn.getAttribute('data-alt') || '';
            main.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-ng-producto]').forEach(function (root) {
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = root.querySelector('input[name="id"]');
      var precio = root.querySelector('[data-ng-precio]');
      var antes = root.querySelector('[data-ng-antes]');
      var boton = root.querySelector('[data-ng-add]');
      var botonTxt = boton ? boton.querySelector('span') : null;
      var dataEl = root.querySelector('[data-ng-variantes]');
      var qty = root.querySelector('[data-ng-qty]');
      var sticky = document.querySelector('[data-ng-sticky]');
      var stickyPrecio = sticky ? sticky.querySelector('[data-ng-sticky-precio]') : null;

      // Cantidad
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            v = b.getAttribute('data-dir') === 'up' ? v + 1 : Math.max(1, v - 1);
            input.value = v;
          });
        });
      }

      // Variantes
      if (dataEl && idInput) {
        var variantes = JSON.parse(dataEl.textContent);
        var formato = root.getAttribute('data-money-format') || '{{amount}}';
        var txtAdd = root.getAttribute('data-txt-add');
        var txtAgotado = root.getAttribute('data-txt-agotado');
        root.querySelectorAll('[data-ng-opcion]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var elegidas = [];
            root.querySelectorAll('[data-ng-fieldset]').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              elegidas.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) {
              return x.options.every(function (o, i) { return o === elegidas[i]; });
            });
            if (!v) return;
            idInput.value = v.id;
            var p = dinero(v.price, formato);
            if (precio) precio.textContent = p;
            if (stickyPrecio) stickyPrecio.textContent = p;
            if (antes) {
              if (v.compare_at_price && v.compare_at_price > v.price) {
                antes.textContent = dinero(v.compare_at_price, formato);
                antes.style.display = '';
              } else { antes.style.display = 'none'; }
            }
            if (boton) {
              boton.disabled = !v.available;
              if (botonTxt) botonTxt.textContent = v.available ? txtAdd : txtAgotado;
            }
          });
        });
      }

      // Barra fija en móvil: aparece cuando el botón principal sale de pantalla
      if (sticky && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(boton);
        var sb = sticky.querySelector('button');
        if (sb && form) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  }

  // Ventana "Combínalo con": añade al carrito sin salir de la página y ofrece complementos
  function initUpsell() {
    document.querySelectorAll('[data-ng-producto]').forEach(function (root) {
      var modal = root.querySelector('[data-ng-upsell]');
      var form = root.querySelector('form[action*="/cart/add"]');
      if (!modal || !form || form.dataset.ngComboListo) return;
      form.dataset.ngComboListo = '1';
      var error = root.querySelector('[data-ng-error]');
      var boton = root.querySelector('[data-ng-add]');

      function abrir() {
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        setTimeout(function () { modal.classList.add('is-open'); }, 20);
        var cerrarBtn = modal.querySelector('.ng-upsell__x');
        if (cerrarBtn) cerrarBtn.focus();
      }
      function cerrar() {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () { modal.hidden = true; }, 250);
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (boton) boton.setAttribute('aria-busy', 'true');
        if (error) error.style.display = 'none';
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        }).then(function (res) {
          if (boton) boton.removeAttribute('aria-busy');
          if (!res.ok) {
            if (error) { error.textContent = res.data.description || res.data.message || 'No se pudo añadir al carrito.'; error.style.display = 'block'; }
            return;
          }
          actualizarCarrito();
          abrir();
        }).catch(function () { form.submit(); });
      });

      modal.querySelectorAll('[data-ng-upsell-cerrar]').forEach(function (el) { el.addEventListener('click', cerrar); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cerrar(); });

      modal.querySelectorAll('[data-ng-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var txt = btn.textContent;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-id')), quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error();
            btn.textContent = '✓ Añadido';
            btn.classList.add('is-added');
            actualizarCarrito();
          }).catch(function () { btn.disabled = false; btn.textContent = txt; });
        });
      });
    });
  }

  // Refresca el icono del carrito de la cabecera (Section Rendering API de Shopify)
  function actualizarCarrito() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      var html = data['cart-icon-bubble'];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var nuevo = tmp.querySelector('.shopify-section') || tmp;
      bubble.innerHTML = nuevo.innerHTML;
    }).catch(function () {});
  }

  function dinero(cents, formato) {
    var n = (cents / 100);
    var con2 = n.toFixed(2);
    var coma = con2.replace('.', ',');
    var sinDec = Math.round(n).toString();
    return formato
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount\s*\}\}/, con2);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleria();
    initProducto();
    initUpsell();
  });
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initGaleria();
    initProducto();
    initUpsell();
  });
})();
